import { render } from "./MatrixType.vue?vue&type=template&id=56f9a8e7&scoped=true"
import script from "./_MatrixType.js?vue&type=script&lang=js&external"
export * from "./_MatrixType.js?vue&type=script&lang=js&external"

import "./_MatrixType.less?vue&type=style&index=0&id=56f9a8e7&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f9a8e7"]])

export default __exports__